import axios from 'axios'
import store from '~/store'
import router from '~/router'
import swal from 'sweetalert2'
import i18n from '~/plugins/i18n'

let sessionTimoutWarning = 1200000 // Display warning in 20 Min.

let sessionWarningTimer

// Start timers.
function StartTimer () {
  sessionWarningTimer = setTimeout(IdleWarning, sessionTimoutWarning)
}

// Reset timers.
function ResetTimer () {
  clearTimeout(sessionWarningTimer)
  StartTimer()
}

// Show idle timeout warning dialog.
function IdleWarning () {
  if (router.currentRoute.name != 'welcome') {
    // Display warning message + refresh if asked
    swal({
      type: 'warning',
      title: i18n.t('session_timeout_warning_title'),
      text: i18n.t('session_timeout_warning_text'),
      reverseButtons: false,
      confirmButtonText: i18n.t('ok'),
      cancelButtonText: i18n.t('cancel')
    }).then(() => {
      // call url for refreshing session
      axios.get('/api/user')
        .then((response) => {
          ResetTimer()
        })
        .catch((error) => {
          console.error(error)
        })
    })
  } else {
    ResetTimer()
  }
}

setTimeout(StartTimer, 3000)

// Request interceptor
axios.interceptors.request.use(request => {
  const token = store.getters['auth/token']
  if (token) {
    request.headers.common['Authorization'] = `Bearer ${token}`
  }

  const locale = store.getters['lang/locale']
  if (locale) {
    request.headers.common['Accept-Language'] = locale
  }

  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request
})

// Response interceptor
axios.interceptors.response.use(response => response, error => {
  try {
    status = error.response.status

    var debug = {
      'url': error.response.config.url,
      'method': error.response.config.method,
      'data': error.response.config.data,
      'date': error.response.headers.date,
      'status': error.response.status,
      'browser': window.navigator.userAgent
    }

    if (status >= 500) {
      swal({
        type: 'error',
        title: i18n.t('error_alert_title'),
        reverseButtons: true,
        confirmButtonText: i18n.t('ok'),
        cancelButtonText: i18n.t('cancel'),
        input: 'textarea',
        inputValue: btoa(JSON.stringify(debug)),
        html: '<p>' + i18n.t('error_alert_text') + '</p><p>Debug infos (for support):</p>'
      })
    }

    if (status == 401 && store.getters['auth/check']) {
      swal({
        type: 'warning',
        title: i18n.t('token_expired_alert_title'),
        text: i18n.t('token_expired_alert_text'),
        reverseButtons: true,
        confirmButtonText: i18n.t('ok'),
        cancelButtonText: i18n.t('cancel')
      }).then(() => {
        store.commit('auth/logout')

        router.push({ name: 'login' })
      })
    }

    // Restart session timeout warning timers
  } catch (error) {
    swal({
      type: 'error',
      title: i18n.t('error_alert_title'),
      text: i18n.t('error_alert_no_connection_text'),
      reverseButtons: true,
      confirmButtonText: i18n.t('ok'),
      cancelButtonText: i18n.t('cancel')
    })
  }

  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./resources/js/plugins/axios.js